<template>
  <v-app id="app">
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="60%" class="pa-0">
        <v-card>
          <v-card-text class="pa-5">
            <h3>
              This site is best viewed on:
              <ul style="list-style: none; padding-top: 10px">
                <li><v-icon>mdi-laptop</v-icon> Desktop</li>
                <li>
                  <v-icon class="rotate-mobile">mdi-cellphone</v-icon> Mobile
                  (landscape mode)
                </li>
              </ul>
            </h3>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false"> OK </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-snackbar v-model="swapNotice" :timeout="2000" top left right
      style="justify-content: center; align-items: center; width: 100%;">
      <div style="margin: 0 auto; max-width: 360px; text-align: center;">
        {{ swapNoticeText }}
      </div>

      <template v-slot:action>
        <v-btn text @click="swapNotice = false">Close</v-btn>
      </template>
    </v-snackbar>

    <TopMenuContainer />
    <Controls v-if="this.$vuetify.breakpoint.name !== 'xs'" />
    <v-container fluid class="pa-0 blue lighten-5">
      <v-row class="ma-0">
        <v-col cols="12" sm="3" :class="{
          'pa-0': true,
          'mt-16': true,
          blue: true,
          'lighten-5': true,
          'extra-zoom': this.$store.getters.isMobile,
        }">
          <SideMenuContainer :side="'A'" />

          <v-col v-if="this.$vuetify.breakpoint.name === 'xs'" cols="12" sm="3" class="pa-0 mt-0">
            <SideBPlaceholder v-show="this.sideBPlaceholder" />
            <SideMenuContainer v-show="!this.sideBPlaceholder" :side="'B'" />
          </v-col>
        </v-col>
        <v-col cols="12" sm="6" class="pa-0">
          <Controls v-if="this.$vuetify.breakpoint.name === 'xs'" />
          <Map />
        </v-col>
        <v-col v-if="this.$vuetify.breakpoint.name !== 'xs'" cols="12" sm="3" :class="{
          'pa-0': true,
          'mt-16': true,
          'extra-zoom': this.$store.getters.isMobile,
        }">
          <SideBPlaceholder v-show="this.sideBPlaceholder" />
          <SideMenuContainer v-show="!this.sideBPlaceholder" :side="'B'" />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Map from "./components/Map.vue";
import TopMenuContainer from "./components/TopMenu/TopMenu.vue";
import SideMenuContainer from "./components/SideMenu/SideMenuContainer.vue";
import SideBPlaceholder from "./components/SideMenu/SideBPlaceholder.vue";
import Controls from "./components/Controls/OpacitySlider.vue";
import Vue from "vue";

import { EventBus } from "./js/DataManagement/EventBus";

import DataManager from "./js/DataManagement/DataManager.js";
import QuerystringManager from "./js/DataManagement/QuerystringManager";
import LayerManager from "./js/LayerManager.js";

export default {
  name: "App",
  components: {
    Map,
    TopMenuContainer,
    SideMenuContainer,
    Controls,
    SideBPlaceholder,
  },
  beforeCreate: function () {
    Vue.prototype.$dataManager = new DataManager();
    Vue.prototype.$layerManager = new LayerManager();
    Vue.prototype.$querystringManager = new QuerystringManager();

    // set state based on &state= , zoom to state extent
    const selectedState = this.$querystringManager.route.query.state
    if (selectedState) {
      this.$nextTick(() => {
        this.$store.commit("setSelectedState", selectedState);
        EventBus.$emit("zoomToState");
      })
    }

    const districtType =
      this.$querystringManager.route.query.districtType ||
      this.$mainConfig.defaultDistrictType;

    this.$store.commit("setActiveDistrictType", districtType);
    this.$store.commit("setMobile");
    let self = this;
    window.addEventListener(
      "resize",
      function () {
        self.$store.commit("setMobile");
      },
      true
    );
  },
  data() {
    return {
      dialog: false,
      sideBPlaceholder: false,
      swapNotice: false,
      swapNoticeText: "",
    };
  },
  watch: {
    "$store.state.sideBProposal": function (val) {
      this.sideBPlaceholder = val.length === 0;
      if (this.sideBPlaceholder) {
        EventBus.$emit("zeroOpacity");
      }

      this.$forceUpdate();
    },
  },
  methods: {
    showSwapNotice(text) {
      this.swapNoticeText = text;
      this.swapNotice = false;
      this.$nextTick(() => {
        this.swapNotice = true;
      });
    },
  },
  mounted: function () {
    EventBus.$on("swap-proposal", (displayname) => {
      this.showSwapNotice('This state\'s districts have not been redrawn mid-decade. Switching map to: ' + displayname);
    });

    if (window.location !== window.parent.location && this.$store.getters.isMobile) {
      document.querySelector("html").classList.add("in-iframe");
    }

    const { selected, propA, propB } = this.$querystringManager.route.query;

    const tablenames = this.$pgConfig.map((d) => d.tablename);
    if (tablenames.includes(propA)) {
      this.$store.commit(`setSideAid`, propA);
      this.$layerManager.showProposal({
        _id: propA,
        _side: "A",
      });
    }

    if (tablenames.includes(propB)) {
      this.$store.commit(`setSideBid`, propB);
      this.$layerManager.showProposal({
        _id: propB,
        _side: "B",
      });
    }

    const selectedLngLat = selected?.split(",").map((l) => +l) ?? [];

    if (selectedLngLat.length === 2) {
      this.$map.once("idle", () => {
        this.$store.commit("setSelectedLngLat", selectedLngLat);

        this.$nextTick(() => {
          EventBus.$emit("select-district-from-url", selectedLngLat);
        });
      });
    }

    if (this.$store.getters.isMobile && window.innerHeight > window.innerWidth) {
      document.querySelector("html").classList.add("in-iframe");
      this.dialog = true;
      setTimeout(() => {
        this.dialog = false;
      }, 4000);
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  overflow: hidden;
}

:root {
  --charcoal: #264653ff;
  --persian-green: #2a9d8fff;
  --orange-yellow-crayola: #e9c46aff;
  --sandy-brown: #f4a261ff;
  --burnt-sienna: #e76f51ff;

  --cg-blue: #0081a7ff;
  --verdigris: #00afb9ff;
  --light-yellow: #fdfcdcff;
  --peach-puff: #fed9b7ff;
  --light-peach-puff: #fff4e9;
  --tan: #eebe8f;
  --bittersweet: #f07167ff;

  --imperial-red: #ec0021;
  --honeydew: rgb(232, 242, 255);
  --powder-blue: rgb(192, 215, 228);
  --celadon-blue: rgb(146, 188, 214);
  --prussian-blue: #1d3557ff;
}

html {
  overflow-y: hidden;
}

html.in-iframe {
  overflow-y: scroll;
}

.rotate-mobile {
  transform: rotate(90deg);
}

.extra-zoom {
  zoom: 0.75;
}

.extra-zoom aside {
  max-height: calc(133vh - 64px);
}

.extra-zoom .pie-chart-div {
  font-size: .75em;
}
</style>
